import { type ChatThread, parseChatThreadCreatedAt, sortChatThreadsByCreatedAt, TITLE_PENDING } from "@repo/agent-chat";
import { CommandEmpty, CommandGroup, CommandItem } from "@repo/ui/components/ui/command";
import { formatDistanceToNow } from "date-fns";

export interface ChatHistorySearchListProps {
  threads: ChatThread[];
  onSelect: (threadId: string) => void;
}

export function ChatHistorySearchList({ threads, onSelect }: ChatHistorySearchListProps) {
  const sorted = sortChatThreadsByCreatedAt(threads);

  return (
    <>
      <CommandEmpty>No chats found.</CommandEmpty>
      <CommandGroup>
        {sorted.map((thread) => {
          const title = thread.title?.trim();
          const when = thread.created_at
            ? formatDistanceToNow(parseChatThreadCreatedAt(thread.created_at), { addSuffix: true })
            : "";
          // cmdk needs a stable string for fuzzy search; use placeholder text when title pending
          return (
            <CommandItem key={thread.id} value={title || TITLE_PENDING} onSelect={() => onSelect(thread.id)}>
              <div className="flex flex-col min-w-0">
                {title ? (
                  <span className="truncate">{title}</span>
                ) : (
                  <span className="shimmer truncate text-muted-foreground">{TITLE_PENDING}</span>
                )}
                {when && <span className="text-xs text-muted-foreground truncate">{when}</span>}
              </div>
            </CommandItem>
          );
        })}
      </CommandGroup>
    </>
  );
}
